import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BiSurfaceCard } from '@euler/app/flows/bi-dashboards/components/ui/BiSurfaceCard';
import { BiTag } from '@euler/app/flows/bi-dashboards/components/ui/BiTag';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
} from '../../functions/biGalleryTypes';
import { TilePreview } from './TilePreview';

/** A category on the index: its name, variant count and a preview. */
export const CategoryTile = memo(
  ({
    category,
    palette,
    width,
    onOpen,
  }: {
    category: BiGalleryCategory;
    palette: BiPalette;
    width: number;
    onOpen: (key: BiGalleryCategoryKey) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <BiSurfaceCard
        accessibilityLabel={`打开 ${category.name}`}
        onPress={() => onOpen(category.key)}
        style={{ width, padding: rpx(14), gap: rpx(10) }}
      >
        <View
          style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(8) }}
        >
          <Typography.Text
            medium
            size={rpx(15)}
            color={aiColors.foreground}
            numberOfLines={1}
            style={{ flexShrink: 1 }}
          >
            {category.name}
          </Typography.Text>
          <BiTag
            text={`${category.variants.length} 种样式`}
            color={aiColors.primary}
          />
        </View>
        <Typography.Text
          size={rpx(12)}
          color={aiColors.mutedForeground}
          numberOfLines={2}
        >
          {category.description}
        </Typography.Text>
        <TilePreview card={category.preview} palette={palette} />
      </BiSurfaceCard>
    );
  },
);
